export enum TouchScrollToTopScrollId {
    HomeTabScrollId = 'homeTabScrollId',
    MentionsTabScrollId = 'mentionsTabScrollId',
    ProfileTabScrollId = 'profileTabScrollId',
    ThreadsTabScrollId = 'threadsTabScrollId',
    SearchTabScrollId = 'searchTabScrollId',
    SearchTabInputId = 'searchTabInputId',
    ExploreTabScrollId = 'exploreTabScrollId',
    WalletTabScrollId = 'walletTabScrollId',
}
